import { render, staticRenderFns } from "./MilestonesTimeLineItem.vue?vue&type=template&id=2ff40a01&scoped=true&"
import script from "./MilestonesTimeLineItem.vue?vue&type=script&lang=js&"
export * from "./MilestonesTimeLineItem.vue?vue&type=script&lang=js&"
import style0 from "./MilestonesTimeLineItem.vue?vue&type=style&index=0&id=2ff40a01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff40a01",
  null
  
)

export default component.exports